export default {
  name: 'refooter',
  props: {
    brand: {
      type: String,
      default: 'LiveMe'
    }
  },
  computed: {
    crtime: function crtime() {
      return new Date().getFullYear();
    }
  }
};